import { AppConfiguration } from "../app-configuration";
export class IscoConfiguration {
   // ISCO
   public static ricercaIsco = AppConfiguration.SECURED + '/api/isco/ricercaIsco/';
   public static ricercaIscoByIdProfilo = AppConfiguration.SECURED + '/api/isco/ricercaIscoByIdProfilo/';
   public static salvaIscoByIdProfilo = AppConfiguration.SECURED + '/api/isco/salvaIscoByIdProfilo/';
   public static eliminaIscoByIdProfilo = AppConfiguration.SECURED + '/api/isco/eliminaIscoByIdProfilo/';
   public static ricercaIscoByIdCompetenza = AppConfiguration.SECURED + '/api/isco/ricercaIscoByIdCompetenza/';
   public static salvaIscoByIdCompetenza = AppConfiguration.SECURED + '/api/isco/salvaIscoByIdCompetenza/';
   public static eliminaIscoByIdCompetenza = AppConfiguration.SECURED + '/api/isco/eliminaIscoByIdCompetenza/';
   public static getCodiciIscoByIdProposta = AppConfiguration.SECURED + '/api/getCodiciIscoByIdProposta/';
   public static getCodiciIscoByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciIscoByIdCompetenza/';
   public static getElencoIsco = AppConfiguration.SECURED + '/api/isco/getElencoIsco/';
   
}